import styled from "styled-components";
import Backdrop from "../Backdrop";
import theme from "../../theme/theme";

const BodyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBody = styled.div`
  max-width: 700px;
  width: 100%;
  background-color: white;
  padding: 40px 40px;
  border-radius: 15px;
  text-align: left;

  @media (max-width: 480px) {
    width: 80%;
    margin: auto;
    padding: 20px 20px;
  }

  .headerMessage {
    font-weight: 700;
    font-size: 32px;
    color: ${theme.colors.primaryStrong2X};

    .crossButton {
      float: right;
      font-size: 20px;
      cursor: pointer;

      @media (max-width: 480px) {
        font-size: 18px;
      }
    }

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  .subHeaderMessage {
    margin-top: 20px;
    font-weight: 700;
    font-size: 17px;
    color: ${theme.colors.primaryStrong2X};

    @media (max-width: 480px) {
      font-size: 14px;
    }
  }
`;

const ThankYouModal = (props) => {
  return (
    <Backdrop>
      <BodyWrapper>
        <ModalBody>
          <div className="headerMessage">
            Thank you for your submission.{" "}
            <div onClick={() => props.onClose(false)} className="crossButton">
              X
            </div>
          </div>
          <div className="subHeaderMessage">
            Your account is being reviewed. Our process typically takes one
            business day. You will receive an email with further instructions to
            complete the account set up.
          </div>
        </ModalBody>
      </BodyWrapper>
    </Backdrop>
  );
};

export default ThankYouModal;
